export const SHIPMENT_STATUSES = {
    PEND: 'Pending',
    PROC: 'In Process',
    PACKD: 'Packed',
    SHIPD: 'Shipped',
    CANCL: 'Canceled',
    HOLD: 'On Hold',
};
